import React from 'react';
import { Zap, Shield, Headphones, DollarSign } from 'lucide-react';
import { advantages } from '../mockData';

const iconMap = {
  Zap: Zap,
  Shield: Shield,
  Headphones: Headphones,
  DollarSign: DollarSign
};

const Advantages = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-purple-600 font-semibold text-sm uppercase tracking-wide mb-3">
            Our Advantage
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-purple-600 mb-4">
            Why Choose BlueLanternOutFitters
          </h2>
          <p className="text-xl text-purple-500 max-w-3xl mx-auto">
            We're not just another fulfillment company. Here's what sets us apart.
          </p>
        </div>

        {/* Advantages Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {advantages.map((advantage, index) => {
            const IconComponent = iconMap[advantage.icon];
            return (
              <div
                key={index}
                className="text-center group"
              >
                <div className="w-20 h-20 mx-auto bg-gradient-to-br from-gray-100 to-gray-50 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:shadow-lg transition-all duration-200">
                  <IconComponent size={36} className="text-purple-600" />
                </div>
                <h3 className="text-xl font-bold text-purple-600 mb-3">
                  {advantage.title}
                </h3>
                <p className="text-purple-500 leading-relaxed">
                  {advantage.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Advantages;
